import React from "react";
import { forwardRef } from "react";
import TextField from "@material-ui/core/TextField";

const PhoneField = (props, ref) => {
  return <TextField {...props} inputRef={ref} name="phone" />;
};

export default forwardRef(PhoneField);
